/*globals $ */

import slick from 'slick-carousel';// eslint-disable-line no-unused-vars

class Carousel {
  constructor($target, options) {
    this.$target = $target;
    this.options = options;
  }

  init(viewMode) {
    let tmpHeight = 0;
    if(this.options[viewMode] != null) {
      this.$target.slick(this.options[viewMode]);
      this.$target.find('.slick-slide').each((i, e) => {
        if(i == 0) {
          tmpHeight = $(e).height();
        } else {
          if(tmpHeight < $(e).height()) {
            tmpHeight = $(e).height();
          }
        }
      });
      this.$target.find('.slick-slide').css('height', tmpHeight);
    } else {
      if(this.$target.hasClass('slick-initialized')) {
        this.$target.slick('unslick');
      }
    }
  }
}

export default Carousel;
